export default __webpack_public_path__ + "static/media/format-bold.8cd5681b.svg";